import { useState } from 'react';
import SeoHead from '../components/SeoHead';
import GalleryLightbox from '../components/GalleryLightbox';
import { imageUrl } from '../lib/images';

export default function ReferencerPage() {
  const references = [
    {
      title: "Ny bundkegle Færch Plast",
      category: "Reparation",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/607118-ny-bundkegle-faerch-plast-cropresize-500x375.webp",
      desc: "Udkørende reparation og montage af ny glasfiberbundkegle hos Færch Plast.",
    },
    {
      title: "Lift / Ommelift",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/334170-ommelift-2-cropresize-500x375.webp",
      desc: "Komposit- og glasfiberkomponenter til Ommelift.",
    },
    {
      title: "Overdækning ø27 meter",
      category: "Overdækning",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/568338-overdaekning-o27-meter-cropresize-500x375.webp",
      desc: "Roterende overdækning Ø27 meter til Søholt Renseanlæg i Silkeborg til minimering af lugtgener.",
    },
    {
      title: "Vakuum støbt front tank",
      category: "Tanke",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/386388-vakuum-stobt-front-tank-cropresize-500x375.webp",
      desc: "Vakuumstøbt front tank i stærk komposit.",
    },
    {
      title: "Trappe til Ulfborg Svømmehal",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/658166-trappe-ulfborg-svoemmehal-scaled-1-cropresize-500x375.webp",
      desc: "Specialfremstillet klorresistent trappe til Ulfborg Svømmehal.",
    },
    {
      title: "Trailer-tank",
      category: "Tanke",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/831627-trailer-tank-scaled-cropresize-500x375.webp",
      desc: "Skræddersyet trailertank til mobil transport af væsker.",
    },
    {
      title: "Dobbelt tank",
      category: "Tanke",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/384707-dobbelt-tank-2019-scaled-e1581424144496-cropresize-500x375.webp",
      desc: "Dobbeltvægget procestank med vinylester barriere-lag.",
    },
    {
      title: "Affaldsstation i glasfiber båd",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/avet-affaldsloesning-molokdomino-fiskekutter-hvidesande1-cropresize-500x375.webp",
      desc: "Fiskekutter med nedgravede Domino containere til Ringkøbing-Skjern Kommune i Hvide Sande.",
    },
    {
      title: "Commercial Barrier (terrorsikring)",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/487569-terrorsikringer-scaled-e1581424026642-cropresize-500x375.webp",
      desc: "Tung terrorsikring i glasfiber udviklet i samarbejde med Rockwool.",
    },
    {
      title: "Mandskabskurv til lift",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/328081-mandskabs-kurv-til-lift-1-scaled-cropresize-500x375.webp",
      desc: "Sikkerhedsgodkendt mandskabskurv i højstyrke glasfiber.",
    },
    {
      title: "Mindre tank",
      category: "Tanke",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/1423553-lille-tank-scaled-cropresize-500x375.webp",
      desc: "Kompakt glasfibertank til procesanlæg og kemikalieopbevaring.",
    },
    {
      title: "Pumpebrønd",
      category: "Brønde",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/2374683-img-1762-cropresize-500x375.webp",
      desc: "Standard og kundetilpasset pumpebrønd til spildevand og regnvand.",
    },
    {
      title: "Indstøbningsbrønd",
      category: "Brønde",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/indstoebningsbroend2-cropresize-500x375.webp",
      desc: "Indsats til renovering af nedslidte pumpebrønde i beton.",
    },
    {
      title: "Mælkekarton til Arla",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/glasfiber-specialopgave-glasfiber-arla-mega-maelkekaton-cropresize-500x375.webp",
      desc: "Kæmpe displaymælkekarton i glasfiber produceret til Arla.",
    },
    {
      title: "Vakuum støbning af vinger",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/641763-vakuum-stoebning-af-vinge-scaled-cropresize-500x375.webp",
      desc: "RTM vakuuminjicering af vingeprofiler.",
    },
    {
      title: "Støbt ventil",
      category: "Specialopgave",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/436493-stoebt-ventil-scaled-cropresize-500x375.webp",
      desc: "Komplekst støbt ventilelement til forsyningssektoren.",
    },
    {
      title: "Renovering af Holstebro Kommune",
      category: "Reparation",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/708644-renovering-holstebro-kommune-scaled-cropresize-500x375.webp",
      desc: "Udkørende renovering og tætning for Holstebro Kommune.",
    },
    {
      title: "Doseringstank",
      category: "Tanke",
      image: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/1002443-doseringstank-1-scaled-cropresize-500x375.webp",
      desc: "Kemikalieresistent doseringstank til procesteknik.",
    },
  ];

  const categories = ['Alle', 'Brønde', 'Tanke', 'Reparation', 'Overdækning', 'Specialopgave'];
  const [selectedCategory, setSelectedCategory] = useState('Alle');

  const filteredReferences = selectedCategory === 'Alle'
    ? references
    : references.filter((r) => r.category === selectedCategory);

  return (
    <>
      <SeoHead
        title="Referencer - RB Glasfiber A/S"
        description="Trappe til Ulfborg Svømmehal, Trailer-tank, Dobbelt tank, Reparation af havebassin, Reparation hos Færch Plast, Affaldsstation i glasfiber båd."
        canonical="https://www.rb-glasfiber.dk/referencer"
        ogImage="https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/dobbelt-tank-2019-scaled-e1581424144496-cropresize-1408x704.webp"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/dobbelt-tank-2019-scaled-e1581424144496-cropresize-1408x704.webp', 'width=1600,quality=80,format=auto')}
            alt="Referencer"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-list-check"></i>
              <span>Dokumenterede opgaver</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-6">
              Referencer
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Gennem årene har RB Glasfiber leveret kvalitetsløsninger til industri, kommuner, forsyningsselskaber og private. Her ses et udvalg af vores dokumenterede emner og opgaver.
            </p>
          </div>
        </div>
      </section>

      {/* Filter and Grid */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {/* Category Filter */}
          <div className="flex flex-wrap items-center gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setSelectedCategory(cat)}
                className={`px-4 py-2 rounded-md text-xs font-bold uppercase tracking-wider transition-all cursor-pointer ${
                  selectedCategory === cat
                    ? 'bg-[#1e9457] text-white shadow-sm'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredReferences.map((ref, idx) => (
              <div
                key={idx}
                className="group rounded-xl overflow-hidden border border-slate-200 bg-white shadow-sm hover:shadow-md transition-all flex flex-col"
              >
                <div className="relative aspect-[4/3] bg-slate-900 overflow-hidden">
                  <img
                    src={imageUrl(ref.image, 'width=600,quality=85,format=auto')}
                    alt={ref.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded bg-slate-900/80 backdrop-blur-xs text-[#22c55e] text-xs font-bold uppercase tracking-wide">
                    {ref.category}
                  </div>
                </div>

                <div className="p-5 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-slate-900 mb-1 group-hover:text-[#1e9457] transition-colors">
                      {ref.title}
                    </h3>
                    <p className="text-sm text-slate-600 leading-relaxed">{ref.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Lightbox Component */}
          <div className="pt-12 border-t border-slate-200">
            <GalleryLightbox
              gallerySlug="specialopgaver"
              title="Komplet Referencegalleri"
              description="Klik på et billede for at udforske projektbillederne i stor visning med tastatur, mus eller swipe."
              columns={4}
            />
          </div>
        </div>
      </section>
    </>
  );
}
